<template>
    <div id="page" class="container-fluid pq-container">
        <header class="header mx-4 mb-4">
            <div class="mt-4">
              <img style="vertical-align: center; width:45px; margin-bottom: 10px; margin-top: 10px; margin-right: 40px;" src="../assets/q-logo.svg">
            </div>
          <b-form>
          <div class="popover-text mt-2 ml-2">
            Status Filters
            <b-button id="popover-target-1" class="popover-text"><font-awesome-icon :icon="['far', 'circle-info']" />
            </b-button>
            <b-popover custom-class="wide-popover" target="popover-target-1" triggers="hover" placement="bottomright">
              <template #title><div class="my-2">Filter Patient Q with Status Filters</div></template>
              <div class="popover-subheader text-center my-2">Filter the view by toggling status filters on and off</div>
              <hr>
              <div class="mb-3"><span class="scheduled-header">Scheduled</span> - This patient has not yet started their Clinic Q question set for this visit.</div>

              <div class="mb-3"><span class="precheck-header">Pre Checked</span> - This patient has completed all Clinic Q questions before appointment time.</div>

              <div class="mb-3"><span class="inprogress-header">In Progress</span> - This patient has started a Clinic Q session but has not yet completed their questions.</div>

              <div class="mb-3"><span class="review-header">Review</span> - This patient needs additional support before being checked in. Open the appointment line on the Patient Q to see detail of why they need review. Call up this patient as needed.</div>

              <div class="mb-3"><span class="checkin-header">Checked In</span> - This patient has completed their Clinic Q questions for this visit, or they have been manually marked as checked in on the Patient Q; check in is the point at which information and payments are pushed into EHR.</div>

              <div class="mb-3"><span class="done-header">Done</span> - Visit is checked in and intake summary was opened or appointment was marked as Done. No further action should be required for this appt.</div>
            </b-popover>
          </div>
            <div class="status-row">
              <div v-for="state in visitStateOptions" class="status-item" :key="state">
                <div>
                  <button name="scheduled" class="btn status-count no-hover-color" :class="backgroundForVisitState(state)"
                          @click.prevent="toggleVisitStateFilter(state)">
                    <div class="mini-status-column" :style="colorForVisitState(state)"/>{{countForVisitState(state)}}
                  </button>
                </div>
                <div>
                  {{ stringForVisitState(state) }}
                </div>
              </div>
            </div>
          </b-form>
            <div class="search-border" style="margin-left: auto; margin-top: 34px;">
                <input
                        class="form-control patient-search"
                        name="patient-search"
                        placeholder="Filter (Patient Name or Mrn)"
                        type="search"
                        autocomplete="off"
                        v-model="searchText"
                />
                <button class="btn btn-default patient-search-submit" type="button">
                    <font-awesome-icon icon="filter"/>
                </button>
            </div>
          <div class="view-button-group">
            <h5 class="mt-4">View:</h5>&nbsp;&nbsp;
          <div class="mt-4">
          <b-form-radio-group id="amPm-radio" v-model="userAmPm" :options="['AM', 'PM', 'All']" button-variant="outline-orange" buttons @change="this.loadVisits"/>

            <button name="providers" class="btn btn-outline-orange providers-filter"
                    @click.prevent="showingLocationList = !showingLocationList">
              <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'location-dot' ]"/>Locations <b-badge v-show="selectedLocationIds.length > 0" variant="orange">{{ selectedLocationIds.length }}</b-badge>
            </button>

            <button name="providers" class="btn btn-outline-orange providers-filter"
                    @click.prevent="showingProviderList = !showingProviderList">
              <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'user-doctor' ]"/>Providers <b-badge v-show="selectedProviderIds.length > 0" variant="orange">{{ selectedProviderIds.length }}</b-badge>
            </button>
          </div>
          </div>
        </header>

        <div class="container-fluid">
            <div class="row visits-header">
                <div class="col-2">Appointment</div>
                <div class="col-1">Status</div>
                <div class="col-2">Shortcuts</div>
                <div class="col-2">Insurance</div>
                <div class="col-1"><span v-show="showPayments">Payment</span></div>
                <div class="col-2">Provider</div>
                <div class="col-2"></div>
            </div>
            <div class="row justify-content-center m-2">
              <b-alert class="col-6" v-if="generalErrorMessage" :show="true" fade variant="danger">
                {{ generalErrorMessage }}
              </b-alert>
            </div>
            <div v-for="visit in filteredVisits" class="row visit-row" :key="visit.visitId">
                <div class="col-12 patient-queue-row" @click.prevent="toggleDetails(visit)">
                    <div class="row align-items-center">
                      <div class="status-column" :style="colorForVisitState(visit.visitState)"/>
                      <div class="col-2 column">
                            <span class="align-top pl-2">
                            <font-awesome-icon icon="plus" v-show="!showingVisitDetails[visit.visitId]"/>
                            <font-awesome-icon icon="minus" v-show="showingVisitDetails[visit.visitId]"/>
                            &nbsp;{{ formatAppointmentDate(visit.appointmentStartDate) }}
                            </span>
                        <div class="row align-items-center">
                          <img class="headshot headshot-small" :src="visitImageUrls[visit.visitId]"/>
                          <div class="patient-name-dob">
                          <span class="align-items-center">
                            <a @click.prevent.prevent="editPatient(visit.organizationPatientId)" href="#" class="patient-name">{{ visit.lastName +', ' + visit.firstName }}&nbsp;&nbsp;<font-awesome-icon size="sm" :icon="['far', 'edit']"/></a><br>
                           {{ formatBirthDate(visit.dob) }}
                          </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-1 column">
                        <font-awesome-icon v-if="visit.patientHasArrived" class="orange mr-1" size="sm" :icon="['far','hospital']"/>
                        <span v-html="statusDisplay(visit)"/>
                      </div>
                      <div v-if="visit.virtualVisitPatientIsAlone" class="col-2 column">
                            <button v-show="visit.virtualVisit" title="Connect with TeleQ" @click.stop="startVirtualVisit(visit)"  type="button" class="btn btn-orange mr-2 video">
                                <font-awesome-icon size="lg" :icon="[ 'far', 'video' ]"/> <span class="pl-2">Patient Waiting {{ patientVirtualVisitWaitTime(visit.VisitId) }}</span>
                            </button>
                      </div>
                      <div v-else class="col-2 column">
                            <button v-if="visit.preCheckEnabled && visit.mobileNumber && !visit.isCheckedIn && !visit.preCheckCompleted" title="Text PreCheck Link" @click.stop="sendSms(visit)" type="button" class="btn btn-outline-orange mr-2 circle">
                                <font-awesome-icon class="orange" size="lg" :icon="[ 'far', 'sms' ]"/></button>
                            <button v-show="showCheckIn(visit)" :disabled="isCheckInDisabled(visit)" title="Check In" @click.stop="confirmCheckIn(visit)" type="button" class="btn btn-outline-orange mr-2 circle">
                                <font-awesome-icon class="orange" size="lg" :icon="[ 'far', 'check' ]"/></button>
                            <button v-show="!visit.isCheckedIn" title="Connect with QPass" @click.stop="showVisitPass(visit)"  type="button" class="btn btn-outline-orange mr-2 circle">
                                <font-awesome-icon class="orange" size="lg" :icon="[ 'far', 'tablet-alt' ]"/>
                            </button>
                            <button v-show="visit.isCheckedIn" title="Toggle Done" @click.stop="toggleProcessed(visit)"  type="button" class="btn btn-outline-orange mr-2 circle">
                              <font-awesome-icon class="orange" size="lg" :icon="[ 'far', 'check-double' ]"/>
                            </button>
                            <button v-show="visit.virtualVisit" title="Connect with TeleQ" @click.stop="startVirtualVisit(visit)"  type="button" class="btn btn-outline-orange mr-2 circle video">
                                <font-awesome-icon class="orange" size="lg" :icon="[ 'far', 'video' ]"/>
                            </button>
                      </div>
                      <div class="col-2 column" v-if="!visit.isWorkersCompVisit">
                         <span v-if="showInsuranceCardIcon(visit)">
                           <img title="Insurance card images on file" class="insurance-card-icon mr-1" src="../assets/InsuranceCaptureIcon.svg">
                        </span>
                        <span v-if="visit.patientInEpisode">
                         <div v-if="showReferralRequired(visit)">
                          <u>Referral Required</u>
                            </div>
                           <font-awesome-icon class="orange mr-1" size="sm" :icon="['far','chart-network']"/>
                        {{ formatInsuranceStatus(visit) }}
                        </span>
                        <span v-if="visit.hasEmployerBenefits === true && visit.patientInEpisode === false">
                          {{ formatInsuranceStatus(visit) }} <br>
                          <div v-if="showReferralRequired(visit)">
                          <u>Referral Required</u>
                            </div>
                           <font-awesome-icon class="orange mr-1" size="sm" :icon="['far','chart-network']"/>Employer Benefits Available
                        </span>
                        <span  v-if="visit.hasEmployerBenefits === false && visit.patientInEpisode === false ">
                          {{ formatInsuranceStatus(visit) }} <br>
                            <div v-if="showReferralRequired(visit)">
                          <u>Referral Required</u>
                            </div>
                        </span>
                      </div>
                      <div class="col-2 column" v-else>
                        <span>Case Policy</span>
                      </div>
                      <div class="col-1 column">
                        <div v-show="visit.patientInEpisode"><strong>Patient Fees Waived</strong></div>
                        <div v-show="showPayments && !visit.isWorkersCompVisit && visit.patientInEpisode === false">
                          <div v-show="(visit.totalAmount - visit.totalPaid) > 0 && !visit.hasPaid"><strong>DUE: </strong>${{ formatNumber(visit.totalAmount - visit.totalPaid) }}</div>
                          <div class="mt-2" v-show="visit.totalPaid > 0"><strong>PAID: </strong>${{ formatNumber(visit.totalPaid) }}</div>
                        </div>
                      </div>
                      <div class="col-2 column">{{ visit.provider ? visit.provider.displayName : 'No Provider Specified' }}</div>
                      <div class="col-2 column text-right p-1">
                            <button :disabled="visit.visitState === 'NeedsReview' || visit.visitState === 'Scheduled' || visit.visitState === 'InProgress'" @click.stop="showFacesheet(visit)" type="button" class="btn btn-outline-orange mr-1 wide-button" @click.prevent=""><font-awesome-icon class="orange mr-2" icon="address-card"/>Summary</button>
                      </div>
                    </div>
                </div>

                <transition name="slide">
                    <div class="col-12" v-show="showingVisitDetails[visit.visitId]">
                      <div class="status-column" :style="colorForVisitState(visit.visitState)"/>
                      <div class="row visit-detail-row">
                            <div class="col-2">
                              <div class="pl-2">
                                <div class="my-2" v-if="visit.isBlocked">
                                    <b><font-awesome-icon size="sm" class="danger" icon="exclamation-triangle"/> {{ visit.blockReason }}</b>
                                    &nbsp;<a href="#" @click.prevent="unblock(visit)">Unblock</a>
                                </div>
                                <span class="field-label">Location: </span>{{ visit.location ? visit.location.name : 'Not Specified'}}<br>
                                <span class="field-label">Service Type: </span>{{ visit.appointmentTypeText }}<br>
                                <span class="field-label">Flow: </span>{{ visit.visitTypeName }}<br>
                                <span class="field-label">MRN: </span>{{ visit.mrn }}<br>
                                <span class="field-label">Patient ID: </span>{{ visit.patientIdFromOrg }}<br>
                                <span class="field-label">Mobile Number: </span>{{ visit.mobileNumber }}<br>
                                <div v-show="visit.preCheckCompleted">
                                    <span class="field-label">Pre-Check Completed: </span>{{ formatPreCheckDate(visit.preCheckDate) }}<br>
                                </div>
                                <div v-show="visit.isCheckedIn">
                                    <span class="field-label">Check In: </span>{{ formatAppointmentDate(visit.checkInDate) }}<br>
                                </div>
                              </div>
                            </div>
                            <div class="col-3">
                              <span v-if="visit.visitState === 'NeedsReview'"><b>Review Reason:</b> {{ visit.needsReviewReason }}<br></span>
                              <span v-if="visit.patientHasArrived">Arrived at Clinic<br></span>
                              <div class="header-label">Sessions</div>
                              <div v-for="session in visit.sessions" :key="session.sessionId">
                              <a @click.prevent.prevent="showModuleStatus(session)" href="#">{{ sessionName(session) }}</a> &nbsp;
                                {{ formatSessionDate(session) }} &nbsp;
                                {{ sessionDuration(session) }} min
                              </div>
                              <div v-if="!visit.sessions || visit.sessions.length == 0">
                                No sessions started.
                              </div>
                              <span v-if="visit.surveyResults > 0">
                                <div class="mt-2">
                                 <div class="header-label">Survey Results</div>
                                <div v-for="result in visit.surveyResults" :key="result.organizationPatientSurveyResultId">
                                <a @click.prevent.prevent="showSurveyResults(result)" href="#">{{ result.name }} </a>&nbsp;
                                  {{ formatDate(result.createdAt) }}&nbsp;
                                  {{ result.score }} score
                                </div>
                                  </div>
                              </span>
                            </div>

                            <div class="col-3">
                                <div v-show="showPayments">
                                    <div v-if="visit.isWorkersCompVisit">
                                        <span class="field-label">Case Policy</span>
                                    </div>
                                    <template v-else>
                                        <div v-if="visit.isSelfPay">
                                          <div class="header-label">Primary Insurance</div>
                                          Self Pay
                                        </div>
                                        <div class="mb-4" v-if="visit.primaryInsurance">
                                          <div class="header-label">Primary Insurance</div>
                                           <img title="Insurance card images on file" v-if="visit.primaryInsurance.cardImagesPresent === true" class="insurance-card-icon mr-1" src="../assets/InsuranceCaptureIcon.svg"><a @click.prevent="editInsurance(visit, 'primary')" href="#">{{ visit.primaryInsurance.insuranceCompany }}&nbsp;<font-awesome-icon size="sm" :icon="['far', 'edit']"/></a>
                                          <div v-if="visit.primaryInsurance && visit.primaryInsurance.verification && (visit.primaryInsurance.verification.insuranceEligibilityStatus == 'InsuranceError' || visit.primaryInsurance.verification.insuranceEligibilityStatus == 'SystemError' || visit.primaryInsurance.verification.insuranceEligibilityStatus == 'NotVerified' || visit.primaryInsurance.verification.insuranceEligibilityStatus == 'NotMapped')">
                                                <b><font-awesome-icon size="sm" class="danger" icon="exclamation-triangle"/> {{ visit.primaryInsurance.verification.verificationError}}</b>
                                            </div>
                                          <div v-if="visit.primaryInsurance && visit.primaryInsurance.verification">
                                            <div v-if="visit.primaryInsurance.verification.insuranceEligibilityStatus === 'Verified'">
                                            <a @click.prevent="showInsuranceVerificationDetails(visit.primaryInsurance.verification)" href="#">Verification Details</a>
                                            </div>
                                            </div>
                                          <div v-if="visit.primaryInsurance">
                                          <div v-if="visit.primaryInsurance.referralRequired === true">
                                            <u>Referral Required</u>
                                          </div>
                                            <div v-if ="visit.primaryInsurance.verification">
                                            <div v-if="visit.primaryInsurance.verification.hasMetIndividualMaxOop === true">
                                            <u>Individual Max Oop Met</u>
                                          </div>
                                            <div v-if="visit.primaryInsurance.verification.hasMetFamilyMaxOop === true && visit.primaryInsurance.verification.hasMetIndividualMaxOop === false">
                                              <u>Family Max Oop Met</u>
                                            </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="mb-4" v-if="visit.secondaryInsurance">
                                          <div class="header-label">Secondary Insurance</div>
                                           <img title="Insurance card images on file" v-if="visit.secondaryInsurance.cardImagesPresent === true" class="insurance-card-icon mr-1" src="../assets/InsuranceCaptureIcon.svg">
                                          <a @click.prevent="editInsurance(visit, 'secondary')" href="#">{{ visit.secondaryInsurance.insuranceCompany }}&nbsp;<font-awesome-icon size="sm" :icon="['far', 'edit']"/></a>
                                            <div v-if="visit.secondaryInsurance && visit.secondaryInsurance.verification && (visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'InsuranceError' || visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'SystemError' || visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'NotVerified' || visit.secondaryInsurance.verification.insuranceEligibilityStatus == 'NotMapped')">
                                                <b><font-awesome-icon size="sm" class="danger" icon="exclamation-triangle"/> {{ visit.secondaryInsurance.verification.verificationError}}</b>
                                            </div>
                                          <div v-if="visit.secondaryInsurance && visit.secondaryInsurance.verification">
                                            <div v-if="visit.secondaryInsurance.verification.insuranceEligibilityStatus === 'Verified'">
                                            <a @click.prevent="showInsuranceVerificationDetails(visit.secondaryInsurance.verification)" href="#">Verification Details</a>
                                            </div>
                                            </div>
                                          <div v-if="visit.secondaryInsurance && visit.secondaryInsurance.referralRequired === true">
                                            <u>Referral Required</u>
                                          </div>
                                          <div v-if ="visit.secondaryInsurance.verification">
                                            <div v-if="visit.secondaryInsurance.verification.hasMetIndividualMaxOop === true">
                                              <u>Individual Max Oop Met</u>
                                            </div>
                                            <div v-if="visit.secondaryInsurance.verification.hasMetFamilyMaxOop === true && visit.secondaryInsurance.verification.hasMetIndividualMaxOop === false">
                                              <u>Family Max Oop Met</u>
                                            </div>
                                          </div>
                                        </div>
                                    </template>
                                  <template v-if="!visit.patientInEpisode">
                                    <div class="mb-4">
                                      <div class="header-label">Visit Charges</div>
                                        <div v-for="(charge, index) in visit.visitCharges" :key="index">
                                            {{ charge.description + " $" + formatNumber(charge.amount) }}
                                        </div>
                                      <a v-show="visit.successfulPayments.length === 0 || isOrgAdmin" href="#" @click.prevent="addCharge(visit)">&nbsp;<font-awesome-icon size="sm" icon="plus"/> Add/Edit Charges</a>
                                    </div>
                                    <div class="mb-4">
                                      <div class="header-label">Visit Payments</div>
                                      <div v-if="visit.successfulPayments">
                                        <div v-for="payment in visit.successfulPayments" :key="payment.organizationPatientPaymentId">
                                          {{ formatDateTime(payment.paymentDate) }} {{payment.cardType}} {{payment.last4}} ${{formatNumber(payment.amount)}} {{payment.discountAmount > 0 ? 'Discount Amount: $' + payment.discountAmount : ''}}
                                          <div><a href="#" v-if="isOrgAdmin && payment.refundableAmount > 0" @click.prevent="refundDialog(payment)">Refund</a></div>
                                        </div>
                                      </div>
                                     <div v-if="!visit.successfulPayments || visit.successfulPayments.length == 0">
                                       No payments made.
                                     </div>
                                    </div>
                                  </template>
                                </div>
                            </div>

                        <div class="col-2">
                          <div class="header-label">Messaging</div>
                          <div>
                            <button v-if="visit.preCheckEnabled && visit.mobileNumber && !visit.isCheckedIn && !visit.preCheckCompleted" @click.stop="sendSms(visit)" class="btn btn-outline-orange m-1 wide-button"><font-awesome-icon class="orange mr-2" :icon="[ 'far', 'sms' ]"/>Send Pre Check</button>
                          </div>
                          <div v-show="visit.location.paymentPassEnabled === true">
                            <button v-if="showQPassForVisit(visit) && visit.mobileNumber" @click.stop="sendPaymentPassSms(visit)" class="btn btn-outline-orange m-1 wide-button"><font-awesome-icon class="orange mr-2" :icon="[ 'far', 'sms' ]"/>Send Q Pass</button>
                          </div>
                          <div>
                            <button v-show="!visit.isCheckedIn && showDashboardPayments" @click.stop="showPaymentPreview(visit)" class="btn btn-outline-orange m-1 wide-button"><font-awesome-icon class="orange mr-2" :icon="[ 'far', 'sms' ]"/>Send Payment</button>
                          </div>
                          <button v-if="organization.customNotificationsEnabled" @click.stop="showNotifications(visit)" class="btn btn-outline-orange m-1 wide-button"><font-awesome-icon class="orange mr-2" :icon="[ 'far', 'sms' ]"/>Send Message</button>
                        </div>

                          <div class="col-2 p-1 button-container" style="padding-top: 0px !important;">
                                <div>
                                  <br>
                                  <div v-show="showCheckIn(visit)">
                                    <button :disabled="isCheckInDisabled(visit)" @click.prevent="confirmCheckIn(visit)" class="btn btn-outline-orange m-1 wide-button">
                                      <font-awesome-icon class="orange mr-2" :icon="[ 'far', 'check' ]"/>Check In
                                    </button>
                                  </div>
                                  <div v-show="visit.location.paymentPassEnabled === true">
                                    <button v-show="showQPassForVisit(visit)" @click.prevent="showPaymentPass(visit)" class="btn btn-outline-orange m-1 wide-button"><font-awesome-icon class="orange mr-2" :icon="[ 'far', 'tablet-alt' ]"/>Connect Q Pass</button>
                                  </div>
                                  <div>
                                    <button v-show="!visit.isCheckedIn" @click.prevent="showVisitPass(visit)" class="btn btn-outline-orange m-1 wide-button"><font-awesome-icon class="orange mr-2" :icon="[ 'far', 'tablet-alt' ]"/>Connect Handheld</button>
                                  </div>
                                  <div>
                                  <button v-show="!visit.isCheckedIn && showDashboardPayments && (visit.totalAmount - visit.totalPaid) > 0" @click.stop="takePayment(visit)" class="btn btn-outline-orange m-1 wide-button">
                                    <font-awesome-icon class="orange mr-2" :icon="['far', 'credit-card-front']"/>Take Payment
                                </button>
                                  </div>
                                  <div v-if="showCashPayments">
                                  <button v-show="!visit.isCheckedIn && showDashboardPayments && (visit.totalAmount - visit.totalPaid) > 0" @click.prevent="showVisitPaymentCash(visit)" class="btn btn-outline-orange m-1 wide-button">
                                    <font-awesome-icon class="orange mr-2" :icon="['far', 'money-check-dollar']"/>Take Cash/Check
                                  </button>
                                  </div>
                                </div>
                                <div>
                                <button v-show="showPayments" :disabled="isReceiptDisabled(visit)" @click.stop="showReceipt(visit)" class="btn btn-outline-orange m-1 wide-button">
                                    <font-awesome-icon class="orange mr-2" :icon="['far', 'file-invoice-dollar']"/>Receipt
                                </button>
                                </div>
                            <div>
                              <button v-show="showPayments" :disabled="isReceiptDisabled(visit)" @click.prevent="selectReceipt(visit)" class="btn btn-outline-orange m-1 wide-button">
                                <font-awesome-icon class="orange mr-2" :icon="['far', 'file-invoice-dollar']"/>Send Receipt
                                <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
                              </button>
                            </div>
                                <div v-show="visit.isCheckedIn === true">
                                    <button v-show="visit.isCheckedIn === true" @click.prevent="toggleProcessed(visit)" class="btn btn-outline-orange m-1 wide-button">
                                      <font-awesome-icon class="orange mr-2" :icon="['far', 'check-double']"/>{{ visit.status === 'Processed' ? 'Undo Done' : 'Set Done' }}
                                    </button>
                                </div>
                                <div v-show="visit.virtualVisit === true">
                                  <div class="button-header">Tele Q</div>
                                  <div>
                                    <button @click.prevent="startVirtualVisit(visit)" class="btn btn-outline-orange m-1 wide-button">
                                      <font-awesome-icon class="orange mr-2" :icon="[ 'far', 'video' ]"/>Connect with TeleQ
                                    </button>
                                  </div>
                                  <div>
                                    <button @click.prevent="sendVirtualVisitSms(visit)" class="btn btn-outline-orange m-1 wide-button">
                                      <font-awesome-icon class="orange mr-2" :icon="[ 'far', 'sms' ]"/>Send TeleQ SMS
                                    </button>
                                  </div>
                                  <div>
                                    <button @click.prevent="sendVirtualVisitEmail(visit)" class="btn btn-outline-orange m-1 wide-button">
                                      <font-awesome-icon class="orange mr-2" :icon="[ 'far', 'envelope' ]"/>Send TeleQ Email
                                    </button>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade print-summary-modal" tabindex="-1" role="dialog" aria-labelledby="printSummaryModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body print-summary-body">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">&times;</span></button>
                    </div>
                </div>
            </div>
        </div>

        <div class="alert alert-secondary" role="alert" v-show="!filteredVisits.length && !generalErrorMessage">
            &nbsp;&nbsp;No visits were found for the specified locations, providers or view
        </div>

        <location-select @saveLocationIds="locationSelectionChanged"
                         :selected-location-ids="selectedLocationIds" :visible="showingLocationList"
                         @update:visible="visible => showingLocationList = visible"></location-select>

        <provider-select @saveProviderIds="providerSelectionChanged"
                         :selected-provider-ids="selectedProviderIds" :visible="showingProviderList"
                         @update:visible="visible => showingProviderList = visible"></provider-select>

        <confirm-modal @confirmed="reminderConfirmed" :title="nextGenTitle"
                       :copy="nextGenReminderCopy" confirmButton="Ok"
                       :visible="showNextGenReminder" :alertOnly="true"
                       @update:visible="visible => showNextGenReminder = false"></confirm-modal>
      <confirm-modal @confirmed="cashPaymentConfirmed" :title="cashPaymentTitle"
                     :copy="cashPaymentConfirmCopy" confirmButton="Ok"
                     :visible="showCashPaymentConfirmed" :alertOnly="true"
                     @update:visible="visible => showCashPaymentConfirmed = false"></confirm-modal>

        <confirm-modal @confirmed="userConfirmed" :title="confirmTitle"
                       :copy="confirmCopy" :confirmButton="confirmButton"
                       :visible="showConfirmation"
                       @update:visible="visible => showConfirmation = visible"></confirm-modal>

        <pdf-view-modal :title="pdfTitle" :url="pdfUrl" :visible="showingPdfModal" :is-face-sheet= true
                        :visit="selectedVisit" @updated="pdfClosed"
                        @update:visible="visible => showingPdfModal = visible"></pdf-view-modal>
        <loading-modal :visible="showingLoadingModal"
                        @update:visible="visible => showingLoadingModal = visible"></loading-modal>
        <edit-insurance-modal :visit-id="editingInsuranceVisitId" @insuranceUpdated="insuranceUpdated" :insurance-details="editingInsurance" :title="insuranceDetailsTitle" :visible="showingInsuranceDetails" @update:visible="visible => showingInsuranceDetails = visible"></edit-insurance-modal>
        <edit-patient-modal :id="editingPatientId" @patientUpdated="patientUpdated" :visible="showingPatientDetails" @update:visible="visible => showingPatientDetails = visible"></edit-patient-modal>
        <visit-charges-modal :title="visitChargeModalTitle" :visit-id="visitChargeVisit.visitId" @chargeAdded="chargeAdded" :visible="showingVisitCharge" @closeModal="closeVisitChargeModal"></visit-charges-modal>
        <visit-pass-modal :title="visitPassTitle" :url="visitPassUrl" :visible="showingVisitPass"
                        @update:visible="visible => showingVisitPass = visible"></visit-pass-modal>
        <send-custom-notification :visible="showingNotificationsModal" :visit-id="notificationVisitId" @notificationSent="notificationSent" @update:visible="visible => showingNotificationsModal = visible"></send-custom-notification>
        <visit-payment-modal :visit="paymentVisit" :visible="showingPayment" @paymentProcessed="paymentProcessed" @update:visible="visible => showingPayment = visible"></visit-payment-modal>
        <visit-payment-link-modal :visit="paymentVisit" :visible="showingPaymentPreview" :patient-id="notificationPatientId" :visit-id="notificationVisitId" @paymentProcessed="paymentLinkProcessed" @update:visible="visible => showingPaymentPreview = visible"></visit-payment-link-modal>
        <visit-intake-module-status-modal :sessionId="moduleSessionId" :visible="showingVisitIntakeModules" @update:visible="visible => showingVisitIntakeModules = visible"></visit-intake-module-status-modal>
        <survey-results-modal :visible="showingSurveyResults" @update:visible="visible => showingSurveyResults = visible" :result="visitSurveyResult"></survey-results-modal>

        <loading-modal :visible="showingLoadingModal" @update:visible="visible => showingLoadingModal = visible"></loading-modal>
      <refund-modal :payment="activePayment" :visible="showingRefundModal" @refundProcessed="refundProcessed"
                    @update:visible="visible => showingRefundModal = visible"></refund-modal>
      <receipt-modal :payments="receiptPayments" :visible="showingReceiptModal" @receiptSent="receiptSent" @update:visible="visible => showingReceiptModal = visible"></receipt-modal>
      <insurance-verification-modal :visible="showingInsuranceVerificationDetails" @update:visible="visible => showingInsuranceVerificationDetails = visible" :verificationDetails="visitInsuranceVerificationDetails" :title="insuranceVerificationModalTitle"></insurance-verification-modal>
    <visit-payment-cash-modal :visit="cashPaymentVisit" :visible="showingVisitPaymentCashModal" @update:visible="visible => showingVisitPaymentCashModal = visible" @cashPaymentProcessed="cashPaymentProcessed"> </visit-payment-cash-modal>
    </div>
</template>

<script>
  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import moment from 'moment-timezone'
  import ProviderSelect from '../components/ProviderSelect'
  import LocationSelect from '../components/LocationSelect'
  import ConfirmModal from '../components/ConfirmModal'
  import PdfViewModal from '../components/PdfViewModal'
  import LoadingModal from '../components/LoadingModal'
  import EditInsuranceModal from '../components/EditInsuranceModal'
  import EditPatientModal from '../components/EditPatientModal'
  import VisitPaymentModal from '../components/VisitPaymentModal'
  import VisitPaymentLinkModal from '../components/VisitPaymentLinkModal'
  import VisitPaymentCashModal from '@/components/VisitPaymentCashModal.vue'
  import VisitChargesModal from '../components/VisitChargesModal'
  import VisitPassModal from '../components/VisitPassModal'
  import SendCustomNotification from '../components/SendCustomNotification'
  import VisitIntakeModuleStatusModal from '../components/VisitIntakeModuleStatusModal'
  import _ from 'lodash'
  import RefundModal from '@/components/RefundModal'
  import ReceiptModal from '@/components/ReceiptModal'
  import SurveyResultsModal from '../components/SurveyResultsModal'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'
  import InsuranceVerificationModal from '@/components/InsuranceVerificationModal.vue'

  export default {
    name: 'patient-queue',

    mixins: [AnalyticsMixin, ErrorsMixin],

    components: { VisitPaymentCashModal, InsuranceVerificationModal, ReceiptModal, SendCustomNotification, VisitChargesModal, ProviderSelect, LocationSelect, ConfirmModal, EditPatientModal, EditInsuranceModal, VisitPaymentModal, VisitPaymentLinkModal, PdfViewModal, LoadingModal, VisitPassModal, VisitIntakeModuleStatusModal, RefundModal, SurveyResultsModal },

    data () {
      return {
        checkedInVisits: [],
        showingProviderList: false,
        showingLocationList: false,
        visits: [],
        visitStateFilter: [],
        searchText: '',
        selectedProviderIds: [],
        selectedLocationIds: [],
        timeZone: moment.tz.guess(),
        userAmPm: null,
        showViewDropdown: false,
        viewOptions: ['Active', 'All', 'Pre Checked', 'Processed'],
        showingVisitDetails: {},
        visitImageUrls: {},
        autoRefreshEnabled: true,
        refreshInterval: 20,
        visitRefundPending: {},
        showingNamePopover: false,
        editingVisit: {
          firstName: '',
          lastName: ''
        },
        pdfUrl: '',
        pdfTitle: '',
        showingPdfModal: false,
        showingLoadingModal: false,
        showingNotificationsModal: false,
        notificationPatientId: 0,
        notificationVisitId: 0,
        editingInsurance: {
          verification: {
            insuranceEligibilityStatus: ''
          }
        },
        editingInsuranceVisitId: 0,
        insuranceDetailsTitle: '',
        showingInsuranceDetails: false,
        editingPatientId: 0,
        showingPatientDetails: false,
        imageRequestsInFlight: 0,
        autoRefreshTimer: null,
        malePlaceHolderImageUrl: 'https://s3.amazonaws.com/health-here-assets/Images/male.png',
        femalePlaceHolderImageUrl: 'https://s3.amazonaws.com/health-here-assets/Images/female.png',
        visitLoadInProgress: false,
        showingVisitCharge: false,
        visitChargeVisit: {
          visitId: 0
        },
        visitChargeModalTitle: '',
        smsSentVisits: {},
        showingVisitPass: false,
        visitPassUrl: '',
        visitPassTitle: 'Visit Pass',
        showConfirmation: false,
        confirmingRefund: true,
        confirmingVisit: null,
        virtualVisitSessionLengths: {},
        sessionLengthUpdateTimer: null,
        showingPayment: false,
        showingPaymentPreview: false,
        paymentVisit: {},
        cashPaymentVisit: {},
        showRefundConfirmation: false,
        confirmRefundTitle: 'Refund payment?',
        confirmRefundCopy: 'Are you sure you want to refund this payment?',
        confirmRefundButton: 'Yes',
        cancelRefundButton: 'No',
        nextGenTitle: 'Update NextGen',
        cashPaymentTitle: 'Cash/Check Payment',
        showNextGenReminder: false,
        showCashPaymentConfirmed: false,
        showingVisitIntakeModules: false,
        showingSurveyResults: false,
        moduleSessionId: '',
        visitStateOptions: ['Scheduled', 'PreChecked', 'InProgress', 'NeedsReview', 'CheckedIn', 'Done'],
        activePayment: {},
        showingRefundModal: false,
        showRefundReminder: false,
        showingReceiptModal: false,
        receiptPayments: [],
        isSaving: false,
        visitSurveyResult: {},
        selectedVisit: 0,
        showingInsuranceVerificationDetails: false,
        visitInsuranceVerificationDetails: {},
        insuranceVerificationModalTitle: 'Insurance Verification Details',
        showingVisitPaymentCashModal: false
      }
    },

    computed: {
      filteredVisits () {
        if (this.searchText) {
          const normalizedSearchText = this.searchText.toLowerCase()
          return this.visits.filter((visit) => {
            return (visit.firstName && visit.firstName.toLowerCase().includes(normalizedSearchText)) ||
              (visit.lastName && visit.lastName.toLowerCase().includes(normalizedSearchText)) ||
              (visit.dob && this.formatBirthDate(visit.dob).includes(normalizedSearchText)) ||
              (visit.mrn && visit.mrn.includes(normalizedSearchText)) ||
              (visit.patientIdFromOrg && visit.patientIdFromOrg.includes(normalizedSearchText))
          })
        } else {
          if (this.visitStateFilter.length === 0) {
            return this.visits
          } else {
            return this.visits.filter((visit) => {
              return this.visitStateFilter.includes(visit.visitState)
            })
          }
        }
      },

      nextGenReminderCopy () {
        if (!this.visitRefundPending || !this.visitRefundPending.payment) {
          return 'We’ve refunded the payments, but the NextGen batch needs to be adjusted.'
        }

        if (!this.$store.organization || !this.$store.organization.timeZoneDesc) {
          return 'We’ve refunded the payments, but the NextGen batch needs to be adjusted.'
        }

        const tz = this.$store.organization.timeZoneDesc
        const paymentdate = moment(this.visitRefundPending.payment.paymentDate).tz(tz).format('MM/DD/YYYY')
        return 'We’ve refunded the payments, but the NextGen batch on ' + paymentdate + ' needs to be adjusted.'
      },

      cashPaymentConfirmCopy () {
        return 'Your cash/check payment was successful.'
      },
      providers () {
        return this.$store.providers
      },

      organization () {
        return this.$store.organization
      },

      user () {
        return this.$store.user
      },

      showPayments () {
        return this.$store.organization.paymentEnabled
      },

      blockDashboardCheckInOnSessionsNotStarted () {
        return this.$store.organization.blockDashboardCheckInOnSessionsNotStarted
      },

      showDashboardPayments () {
        return this.$store.organization.dashboardPaymentEnabled
      },

      showCashPayments () {
        return this.$store.organization.cashPaymentsEnabled
      },

      isAdmin () {
        return this.$store.isAdmin
      },

      isOrgAdmin () {
        return this.$store.isOrgAdmin
      },

      isSearching () {
        if (this.searchText) {
          return true
        }

        return false
      },

      confirmTitle () {
        if (this.confirmingRefund) {
          return 'Void Copayment?'
        } else {
          return 'Confirm Check In'
        }
      },

      confirmButton () {
        if (this.confirmingRefund) {
          return 'Void'
        } else {
          return 'Check In'
        }

      },

      confirmCopy () {
        if (this.confirmingRefund) {
          return 'Are you sure that you want to void this copayment?'
        } else {
          return 'By manually checking this patient in, Health Here will send any related documents and messages to your EMR. If the patient has not completed some questions, there may be blanks or incomplete information.'
        }
      },

      amOrPm () {
        const hour = moment(new Date()).hour()
        if (hour > 0 && hour < 13) {
          return 'AM'
        } else {
          return 'PM'
        }
      }
    },

    watch: {
      autoRefreshEnabled (newValue, oldValue) {
        if (newValue === true) {
          this.refreshVisits()
        }
      }
    },

    methods: {
      formatDate (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY')
        } else {
          return ''
        }
      },

      locationSelectionChanged (selectedIds) {
        this.$log.info('locationSelectionChanged: ', selectedIds)
        this.selectedLocationIds = selectedIds
        localStorage.setItem('patientQueueSelectedLocationIds', JSON.stringify(this.selectedLocationIds))
        this.showingLocationList = false
        this.loadVisits()
      },

      providerSelectionChanged (selectedIds) {
        this.$log.info('providerSelectionChanged: ', selectedIds)
        this.selectedProviderIds = selectedIds
        localStorage.setItem('patientQueueSelectedProviderIds', JSON.stringify(this.selectedProviderIds))
        this.showingProviderList = false
        this.loadVisits()
      },

      editPatient (patientId) {
        this.$router.push({ name: 'patient-detail', params: { id: patientId } })
      },

      patientUpdated (updatedPatient) {
        // TODO: We should update the structure of the visits list to be able to support updating the patient details directly
        this.showingPatientDetails = false
        this.loadVisits()
      },

      insuranceUpdated () {
        this.showingInsuranceDetails = false
        this.loadVisits()
      },

      addCharge (visit) {
        this.visitChargeModalTitle = 'Visit Charges for ' + visit.firstName + ' ' + visit.lastName
        this.visitChargeVisit = visit
        this.showingVisitCharge = true
      },

      chargeAdded (charge) {
        this.showingVisitCharge = false
        this.loadVisits()
      },

      closeVisitChargeModal (updated) {
        this.showingVisitCharge = false
        if (updated) {
          this.loadVisits()
        }
      },

      showNotifications (visit) {
        this.notificationVisitId = visit.visitId
        this.showingNotificationsModal = true
      },

      showPaymentPreview (visit) {
        this.notificationPatientId = visit.organizationPatientId
        this.notificationVisitId = visit.visitId
        this.showingPaymentPreview = true
      },

      notificationSent (notification) {
        this.notificationVisitId = 0
        this.showingNotificationsModal = false
      },
      cashPaymentProcessed (response) {
        this.showingVisitPaymentCashModal = false
        this.showCashPaymentConfirmed = true
      },

      setupSessionLengthTimer () {
        if (this.sessionLengthUpdateTimer) {
          window.clearInterval(this.sessionLengthUpdateTimer)
        }

        this.sessionLengthUpdateTimer = window.setInterval(this.updateVirutalVisitSessionLengths, 100)
      },

      updateVirutalVisitSessionLengths () {
        for (const visit of this.filteredVisits) {
          if (visit.virtualVisitWaitingSince) {
            const startTime = moment(visit.virtualVisitWaitingSince)
            this.$set(this.virtualVisitSessionLengths, visit.VisitId, moment().diff(startTime))
          } else {
            this.$delete(this.virtualVisitSessionLengths, visit.VisitId)
          }
        }
      },

      patientVirtualVisitWaitTime (visitId) {
        const elapsedMillis = this.virtualVisitSessionLengths[visitId]

        if (elapsedMillis > 0) {
          const hours = Math.floor((elapsedMillis / 1000) / 60 / 60)
          let remainder = elapsedMillis - (hours * 60 * 60 * 1000)
          let minutes = Math.floor(remainder / 1000 / 60)
          remainder = remainder - (minutes * 60 * 1000)
          const seconds = Math.floor(remainder / 1000)

          if (!minutes) {
            minutes = 0
          }

          if (hours) {
            return hours + ':' + ('00' + minutes).slice(-2) + ':' + ('00' + seconds).slice(-2)
          } else {
            return ('00' + minutes).slice(-2) + ':' + ('00' + seconds).slice(-2)
          }
        }
      },

      startVirtualVisit (visit) {
        if (visit.virtualVisit === true) {
          this.$router.push('/virtual-visit/' + visit.visitId)
        }
      },

      editInsurance (visit, priority) {
        if (priority === 'primary') {
          this.insuranceDetailsTitle = visit.firstName + ' ' + visit.lastName + ' - Primary Insurance'
          this.editingInsurance = visit.primaryInsurance
          this.editingInsuranceVisitId = visit.visitId
        } else {
          this.insuranceDetailsTitle = visit.firstName + ' ' + visit.lastName + ' - Secondary Insurance'
          this.editingInsurance = visit.secondaryInsurance
          this.editingInsuranceVisitId = visit.visitId
        }
        this.showingInsuranceDetails = true
      },

      showReceipt (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        this.pdfTitle = 'Receipt for ' + visit.lastName + ', ' + visit.firstName
        api.get('/Dashboard/Download/' + visit.visitId + '/Receipt/', {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/pdf' }
        }).then(response => {
          this.trackEvent('Visit', 'Receipt', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'Receipt', 'Show', visit.visitId)

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'Receipt.pdf')
          } else {
            this.pdfUrl = URL.createObjectURL(response.data)
            this.showingPdfModal = true
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'ReceiptError', error.message)
            this.$log.error('Error attempting to load receipt: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      takePayment (visit) {
        this.paymentVisit = visit
        this.showingPayment = true
      },

      paymentProcessed (payment) {
        this.showingPayment = false
        this.loadVisits()
      },

      paymentLinkProcessed (payment) {

      },

      showFacesheet (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        this.selectedVisit = visit
        this.pdfTitle = 'Summary for ' + visit.lastName + ', ' + visit.firstName
        api.get('/Dashboard/Download/' + visit.visitId + '/Facesheet/', {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/pdf' }
        }).then(response => {
          this.trackEvent('Visit', 'Facesheet', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'Facesheet', 'Show', visit.visitId)
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'facesheet.pdf')
          } else {
            this.pdfUrl = URL.createObjectURL(response.data)
            this.showingPdfModal = true
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'FacesheetError', error.message)
            this.$log.error('Error attempting to load facesheet: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      showVisitPass (visit) {
        this.clearAllErrors()
        this.visitPassTitle = 'QPass for ' + visit.lastName + ', ' + visit.firstName
        api.post('/Dashboard/VisitPass/' + visit.visitId, {
          responseType: 'blob',
          headers: { 'Content-Type': 'image/png' }
        }).then(response => {
          this.trackEvent('Visit', 'QPass', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'QPass', 'Show', visit.visitId)
          this.visitPassUrl = 'data:image/png;base64,' + response.data.base64ImageData
          this.showingVisitPass = true
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'QPassError', error.message)
            this.$log.error('Error attempting to load visit pass: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      showPaymentPass (visit) {
        this.clearAllErrors()
        this.visitPassTitle = 'QPass for ' + visit.lastName + ', ' + visit.firstName
        api.post('/Dashboard/PaymentPassImage/' + visit.visitId, {
          responseType: 'blob',
          headers: { 'Content-Type': 'image/png' }
        }).then(response => {
          this.trackEvent('Visit', 'PaymentPass', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'PaymentPass', 'Show', visit.visitId)
          this.visitPassUrl = 'data:image/png;base64,' + response.data.base64ImageData
          this.showingVisitPass = true
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'PaymentPass', error.message)
            this.$log.error('Error attempting to load payment pass: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      loadVisits (silent = false) {
        this.clearAllErrors()
        if (this.visitLoadInProgress) {
          return
        }
        if (this.selectedLocationIds.length === 0 && this.selectedProviderIds.length === 0) {
          this.addErrorForField('exception', 'Please select some Providers or Locations to see the visits for today.')
          this.$scrollToTop()
          return
        }
        if (!silent) {
          this.showingLoadingModal = true
        }
        const parameters = {
          providerIds: this.selectedProviderIds,
          locationIds: this.selectedLocationIds,
          timeZone: this.timeZone,
          amPm: this.userAmPm
        }
        this.visitLoadInProgress = true
        api.post('/Dashboard/PatientQueue', parameters).then(response => {
          if (!silent) {
            this.trackEvent('PatientQueue', 'Load', 'ResponseTime', response.config.requestDuration)
          }
          this.visits = response.data
          this.setupSessionLengthTimer()

          if (this.autoRefreshEnabled) {
            if (this.autoRefreshTimer) {
              clearTimeout(this.autoRefreshTimer)
            }
            this.autoRefreshTimer = setTimeout(this.refreshVisits, this.refreshInterval * 1000)
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            const isTimeout = error.code === 'ECONNABORTED'
            if (!isTimeout || !silent) {
              this.trackEvent('PatientQueue', 'LoadError', error.message)
              this.$log.error('Error attempting to load appointments: ' + error.message, error)
              this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
              if (error.response && error.response.data) {
                this.setErrorsFromResponse(error.response.data)
              } else {
                this.setFromApiErrorResponse(error)
              }
            }
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
              if (this.autoRefreshTimer) {
                clearTimeout(this.autoRefreshTimer)
              }
              this.autoRefreshEnabled = false
            }
            if (this.autoRefreshEnabled) {
              if (this.autoRefreshTimer) {
                clearTimeout(this.autoRefreshTimer)
              }
              this.autoRefreshTimer = setTimeout(this.refreshVisits, this.refreshInterval * 1000)
            }
          }
        }).then(() => {
          this.visitLoadInProgress = false
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 150)
          this.updateVisitImageUrls()
        })
      },

      updateImageUrlForVisit (visitId, gender) {
        this.clearAllErrors()
        const hasCurrentUrl = Object.prototype.hasOwnProperty.call(this.visitImageUrls, visitId)
        if (hasCurrentUrl) {
          // Check if expired
          const currentUrl = this.visitImageUrls[visitId]
          if (currentUrl !== this.malePlaceHolderImageUrl && currentUrl !== this.femalePlaceHolderImageUrl && this.isS3UrlExpired(currentUrl)) {
            delete this.visitImageUrls[visitId]
          }
        }
        // Try and get the patient image url or use placeholder
        if (Object.prototype.hasOwnProperty.call(this.visitImageUrls, visitId) === false) {
          // Try and load the url
          this.trackEvent('Visit', 'Image', 'Load', visitId)
          api.get('/Dashboard/PatientPhoto/' + visitId).then(response => {
            this.trackEvent('Visit', 'Image', 'Load', visitId)
            this.trackEvent('Visit', 'Image', 'ResponseTime', response.config.requestDuration)

            if (response.data.url) {
              this.$set(this.visitImageUrls, visitId, response.data.url)
            } else if (gender !== null) {
              if (gender.toLowerCase() === 'male') {
                this.$set(this.visitImageUrls, visitId, this.malePlaceHolderImageUrl)
              } else if (gender.toLowerCase() === 'female') {
                this.$set(this.visitImageUrls, visitId, this.femalePlaceHolderImageUrl)
              }
            }
          }).catch(error => {
            if (!this.$store.canHandleNetworkError(error)) {
              this.trackEvent('Visit', 'ImageError', error.message)
              this.$log.error('Error attempting to load image url.', error)
              this.setFromApiErrorResponse(error)
            }
          })
        }
      },

      updateVisitImageUrls () {
        this.clearAllErrors()
        if (this.imageRequestsInFlight > 0) {
          // We are already loading the images
          return
        }
        for (const visit of this.visits) {
          const hasCurrentUrl = Object.prototype.hasOwnProperty.call(this.visitImageUrls, visit.visitId)
          if (hasCurrentUrl) {
            // Check if expired
            const currentUrl = this.visitImageUrls[visit.visitId]
            if (currentUrl !== this.malePlaceHolderImageUrl && currentUrl !== this.femalePlaceHolderImageUrl && this.isS3UrlExpired(currentUrl)) {
              delete this.visitImageUrls[visit.visitId]
            }
          }
          if (Object.prototype.hasOwnProperty.call(this.visitImageUrls, visit.visitId) === false) {
            if (visit.hasProfileImage === false && visit.gender !== null) {
              if (visit.gender.toLowerCase() === 'male') {
                this.$set(this.visitImageUrls, visit.visitId, this.malePlaceHolderImageUrl)
              } else if (visit.gender.toLowerCase() === 'female') {
                this.$set(this.visitImageUrls, visit.visitId, this.femalePlaceHolderImageUrl)
              }

              continue
            }
            // Try and load the url
            this.imageRequestsInFlight += 1
            api.get('/Dashboard/PatientPhoto/' + visit.visitId).then(response => {
              this.trackEvent('Visit', 'VisitImage', 'ResponseTime', response.config.requestDuration)
              if (response.data.url) {
                this.$set(this.visitImageUrls, visit.visitId, response.data.url)
              } else if (visit.gender !== null) {
                if (visit.gender.toLowerCase() === 'male') {
                  this.$set(this.visitImageUrls, visit.visitId, this.malePlaceHolderImageUrl)
                } else if (visit.gender.toLowerCase() === 'female') {
                  this.$set(this.visitImageUrls, visit.visitId, this.femalePlaceHolderImageUrl)
                }

              }
            }).catch(error => {
              if (!this.$store.canHandleNetworkError(error)) {
                this.trackEvent('Visit', 'ImageError', error.message)
                this.$log.error('Error attempting to load image url.', error)
                this.setFromApiErrorResponse(error)
              }
            }).then(() => {
              this.imageRequestsInFlight -= 1
            })
          }
        }
      },

      isS3UrlExpired (url) {
        if (!url) {
          return true
        }

        let isExpired = false
        const urlParts = url.trim().split('?')
        if (urlParts[1]) {
          urlParts[1].split('&').forEach(param => {
            const parts = param.replace(/\+/g, ' ').split('=')
            const key = decodeURIComponent(parts.shift())
            const val = parts.length > 0 ? decodeURIComponent(parts.join('=')) : null

            if (key === 'Expires' && val) {
              const expireDate = moment(val, 'X')
              if (expireDate.isValid()) {
                if (expireDate <= moment()) {
                  isExpired = true
                }
              }
            }
          })

          return isExpired
        }
      },

      reminderConfirmed (confirmed) {
        this.showNextGenReminder = false
      },
      cashPaymentConfirmed (confirmed) {
        this.showCashPaymentConfirmed = false
      },
      isCheckInDisabled (visit) {
        if (visit.isBlocked) {
          return true
        }

        if (!this.blockDashboardCheckInOnSessionsNotStarted) {
          return false
        }

        if (visit.visitState === 'Scheduled') {
          return true
        }

        return false
      },

      isReceiptDisabled (visit) {
        if (visit.successfulPayments && visit.successfulPayments.length > 0) {
          return false
        }

        return true
      },

      confirmCheckIn (visit) {
        if (visit.preCheckCompleted) {
          this.checkIn(visit)
        } else {
          this.confirmingRefund = false
          this.confirmingVisit = visit
          this.showConfirmation = true
        }
      },

      checkIn (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        visit.status = 'Pending Check In'
        if (!this.checkedInVisits.includes(visit.visitId)) {
          this.checkedInVisits.push(visit.visitId)
        }
        api.post('/Dashboard/VisitCheckIn/' + visit.visitId).then(response => {
          this.trackEvent('Visit', 'CheckIn', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'CheckIn', 'Complete', visit.visitId)
          this.loadVisits()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'CheckInError', error.message)
            this.$log.error('Error checking in patient: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      toggleSkipInsurance (visit) {
        this.showingLoadingModal = true
        this.clearAllErrors()
        api.post('/Dashboard/SkipInsurance/' + visit.visitId + '/' + (visit.skipInsurance ? 'false' : 'true')).then(response => {
          this.trackEvent('Visit', 'SkipInsurance', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'SkipInsurance', visit.skipInsurance ? 'false' : 'true', visit.visitId)

          this.loadVisits()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'SkipInsuranceError', error.message)
            this.$log.error('Error toggling skip insurance flag: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      toggleProcessed (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        api.post('/Dashboard/SetProcessed/' + visit.visitId + '/' + (visit.status === 'Processed' ? 'false' : 'true')).then(response => {
          this.trackEvent('Visit', 'SetProcessed', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'SetProcessed', visit.skipInsurance ? 'false' : 'true', visit.visitId)

          this.loadVisits()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'SetProcessedError', error.message)
            this.$log.error('Error toggling processed status: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      unblock (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        api.post('/Dashboard/Unblock/' + visit.visitId).then(response => {
          this.trackEvent('Visit', 'Unblock', 'ResponseTime', response.config.requestDuration)
          this.loadVisits()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'UnblockError', error.message)
            this.$log.error('Error unblocking visit: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      sendSms (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        api.post('/Dashboard/SendSms/' + visit.visitId).then(response => {
          this.trackEvent('Visit', 'SendSms', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'SendSms', 'Sent', visit.visitId)
          this.$set(this.smsSentVisits, visit.visitId, true)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            let message = error.message
            if (error.response && error.response.data) {
              if (error.response.data.mobileNumber && error.response.data.mobileNumber.length > 0) {
                message = error.response.data.mobileNumber[0]
              }
            }
            this.trackEvent('Visit', 'SendSmsError', message)
            this.$log.error('Error sending sms: ' + message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      sendPaymentPassSms (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        api.post('/Dashboard/SendPaymentPassSms/' + visit.visitId).then(response => {
          this.trackEvent('Visit', 'SendPaymentPassSms', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'SendPaymentPassSms', 'Sent', visit.visitId)
          this.$set(this.smsSentVisits, visit.visitId, true)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'SendPaymentPassSms', error.message)
            this.$log.error('Error sending sms: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      sendVirtualVisitSms (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        api.post('/Dashboard/SendVirtualVisitSms/' + visit.visitId).then(response => {
          this.trackEvent('Visit', 'SendVirtualVisitSms', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'SendVirtualVisitSms', 'Sent', visit.visitId)
          this.$set(this.smsSentVisits, visit.visitId, true)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'SendVirtualVisitSmsError', error.message)
            this.$log.error('Error sending sms: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      sendVirtualVisitEmail (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        api.post('/Dashboard/SendVirtualVisitEmail/' + visit.visitId).then(response => {
          this.trackEvent('Visit', 'SendVirtualVisitEmail', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'SendVirtualVisitEmail', 'Sent', visit.visitId)
          this.$set(this.smsSentVisits, visit.visitId, true)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'SendVirtualVisitEmailError', error.message)
            this.$log.error('Error sending email: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },

      smsSent (visit) {
        return this.smsSentVisits[visit.visitId] === true
      },

      durationForVisit (visit) {
        if (visit.session !== null) {
          const startTime = moment(visit.session.startTime)
          if (visit.isCheckedIn) {
            const checkInTime = moment(visit.checkInDate)
            return moment.duration(checkInTime.diff(startTime))
          } else {
            return startTime.fromNow()
          }
        }
      },

      isVisitStalled (visit) {
        if (visit.status === 'In Progress' && visit.session && this.checkedInVisits.indexOf(visit.visitId) === -1) {
          const sessionStart = moment(visit.session.startTime)
          const now = moment()
          if (now.diff(sessionStart, 'minutes') > 15) {
            return true
          }
        }

        return false
      },

      showCheckIn (visit) {
        return !visit.isCheckedIn && this.checkedInVisits.indexOf(visit.visitId) === -1
      },

      kioskNameForVisit (visit) {
        if (visit.sessions) {
          for (const session of visit.sessions) {
            if (session.kiosk && session.kiosk.name) {
              return session.kiosk.name
            }
          }

          return ''
        }
      },

      refreshVisits () {
        if (this.autoRefreshEnabled) {
          this.loadVisits(true)
        }
      },

      toggleDetails (visit) {
        if (!this.showingVisitDetails[visit.visitId]) {
          // Try and update the image url when opening detail view
          this.updateImageUrlForVisit(visit.visitId, visit.gender)
        }

        this.$set(this.showingVisitDetails, visit.visitId, !this.showingVisitDetails[visit.visitId])
      },

      formatBirthDate (dob) {
        return moment(dob).utc().format('MM/DD/YYYY')
      },

      formatAppointmentDate (date) {
        return moment(date).format('h:mm a')
      },

      formatPreCheckDate (date) {
        return moment(date).format('MM/DD h:mm a')
      },

      sessionName (session) {
        if (session.kiosk) {
          return session.kiosk.name
        }

        return 'Web'
      },

      formatSessionDate (session) {
        if (session && session.startTime) {
          return moment(session.startTime).format('MM/DD/YYYY')
        }
      },

      refundPayment (visit) {
        if (!this.isOrgAdmin) {
          return
        }

        this.confirmingRefund = true
        this.visitRefundPending = visit
        this.showConfirmation = true
      },

      userConfirmed (confirmation) {
        this.showConfirmation = false
        if (this.confirmingRefund) {
          if (confirmation) {
            this.refund()
          }
          this.visitRefundPending = {}
        } else {
          if (confirmation) {
            this.checkIn(this.confirmingVisit)
          }
          this.confirmingVisit = null
        }
      },

      refund () {
        this.clearAllErrors()
        api.post('/Dashboard/Refund/' + this.visitRefundPending.payment.organizationPatientPaymentId).then(response => {
          this.trackEvent('Visit', 'Void', 'ResponseTime', response.config.requestDuration)
          if (this.visitRefundPending.visitId) {
            this.trackEvent('Visit', 'Void', 'Success', this.visitRefundPending.visitId)
          }
          this.visitRefundPending = {}
          this.confirmingRefund = false
          this.showConfirmation = false
          const data = response.data

          if (data.remindUser === true && data.authOnly === false) {
            this.showNextGenReminder = true
          }

          this.loadVisits()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'VoidError', error.message)
            this.$log.error('Error attempting to void payment.', error)
            this.setFromApiErrorResponse(error)
          }
        })
      },

      handleLogin (authenticated) {
        if (authenticated) {
          this.loadVisits()
        }
      },

      pdfClosed () {
        this.loadVisits()
      },

      handleOrgChange (newOrg, event) {
        this.$log.info(newOrg)
        localStorage.removeItem('patientQueueSelectedProviderIds')
        localStorage.removeItem('patientQueueSelectedLocationIds')
        this.visits = []
        this.selectedProviderIds = []
        this.selectedLocationIds = []
        this.loadVisits()
      },

      handleVisibilityChange () {
        if (document.hidden) {
          this.autoRefreshEnabled = false
          if (this.autoRefreshTimer) {
            clearTimeout(this.autoRefreshTimer)
          }
        } else {
          if (this.autoRefreshEnabled === false) {
            this.autoRefreshEnabled = true
            this.refreshVisits()
          }
        }
      },

      showQPassForVisit (visit) {
        if (visit.isCheckedIn) {
          return false
        }

        if (visit.primaryInsurance && visit.primaryInsurance.verification && visit.primaryInsurance.verification.insuranceEligibilityStatus !== 'Verified') {
          return true
        }

        if (visit.secondaryInsurance && visit.secondaryInsurance.verification && visit.secondaryInsurance.verification.insuranceEligibilityStatus !== 'Verified') {
          return true
        }

        if (visit.totalAmount - visit.totalPaid > 0) {
          return true
        }

        return false
      },

      colorForVisitState (state) {
        if (state === 'Scheduled') {
          return 'background:#DDE2E6;'
        } else if (state === 'InProgress') {
          return 'background:#528CC5;'
        } else if (state === 'PreChecked') {
          return 'background:#8970B5;'
        } else if (state === 'NeedsReview') {
          return 'background:#C52525;'
        } else if (state === 'CheckedIn') {
          return 'background:#F2A43A;'
        } else if (state === 'Done') {
          return 'background:#61CC6B;'
        } else {
          return 'background:#FFFFFF;'
        }
      },

      backgroundForVisitState (state) {
        if (this.visitStateFilter.includes(state)) {
          return 'btn-orange'
        } else {
          return 'btn-outline-orange'
        }
      },

      stringForVisitState (state) {
        if (state === 'InProgress') {
          return 'In Progress'
        } else if (state === 'PreChecked') {
          return 'Pre Checked'
        } else if (state === 'NeedsReview') {
          return 'Review'
        } else if (state === 'CheckedIn') {
          return 'Checked In'
        } else {
          return state
        }
      },

      statusDisplay (visit) {
        if (visit.visitState === 'InProgress' && visit.sessions && visit.sessions.length > 0) {
          const sessions = visit.sessions
          const lastSession = sessions.at(0)

          return 'In Progress<br>' + this.sessionName(lastSession)
        }

        return this.stringForVisitState(visit.visitState)
      },

      countForVisitState (state) {
        return this.visits.filter(visit => {
          return visit.visitState === state
        }).length
      },

      sessionDuration (session) {
        if (session && session.startTime) {
          const startTime = moment(session.startTime)
          const lastTime = moment(session.lastSeenAt)
          return moment.duration(lastTime.diff(startTime)).minutes()
        }
      },

      showModuleStatus (session) {
        this.moduleSessionId = session.sessionId
        this.showingVisitIntakeModules = true
      },

      showSurveyResults (result) {
        this.visitSurveyResult = result
        this.showingSurveyResults = true
      },

      toggleVisitStateFilter (state) {
        if (this.visitStateFilter.includes(state)) {
          this.visitStateFilter = this.visitStateFilter.filter(visitState => {
            return visitState !== state
          })
        } else {
          this.visitStateFilter.push(state)
        }

        if (this.visitStateFilter.length === 0) {
          this.visitStateFilter = this.visitStateOptions
        }

        localStorage.setItem('patientQueueViewFilter', JSON.stringify(this.visitStateFilter))
      },

      showInsuranceCardIcon (visit) {
        if (visit.primaryInsurance && visit.secondaryInsurance && visit.primaryInsurance.cardImagesPresent === true && visit.secondaryInsurance.cardImagesPresent === true) {
          return true
        }
        if (visit.primaryInsurance && !visit.secondaryInsurance && visit.primaryInsurance.cardImagesPresent === true) {
          return true
        }
        if (visit.secondaryInsurance && !visit.primaryInsurance && visit.secondaryInsurance.cardImagesPresent === true) {
          return true
        }
        return false
      },

      showReferralRequired (visit) {
        if (visit.primaryInsurance && visit.primaryInsurance.referralRequired === true) {
          return true
        }
        return visit.secondaryInsurance && visit.secondaryInsurance.referralRequired === true
      },
      formatInsuranceStatus (visit) {
        if (visit.activeEstimate) {
          let name = 'Episodic: '
          if (visit.activeEstimate.employer && visit.activeEstimate.employer.name) {
            name += visit.activeEstimate.employer.name
          } else {
            name += 'Self Pay'
          }
          return name
        }
        return _.startCase(visit.insuranceStatus)
      },

      formatDateTime (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY hh:mmA')
        } else {
          return ''
        }
      },

      refundProcessed () {
        this.showRefundReminder = true
        this.loadVisits()
        this.$nextTick(() => {
          this.showingRefundModal = false
        })
      },

      refundDialog (payment) {
        this.activePayment = payment
        this.showingRefundModal = true
      },

      formatNumber (number) {
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return '0.00'
      },

      selectReceipt (visit) {
        this.clearAllErrors()
        if (visit.successfulPayments.length === 1) {
          this.isSaving = true
          api.post('Dashboard/Receipt/' + visit.successfulPayments[0].organizationPatientPaymentId).then(response => {
            this.trackEvent('Visit', 'SendReceipt', 'ResponseTime', response.config.requestDuration)
            this.isSaving = false
          }).catch(error => {
            if (!this.$store.canHandleNetworkError(error)) {
              this.setFromApiErrorResponse(error)
              this.$log.error('Error attempting to send receipt: ' + error.message, error)
              this.addErrorForField('exception', error.message)
            }
            this.isSaving = false
          })
        } else {
          this.receiptPayments = visit.successfulPayments
          this.showingReceiptModal = true
        }
      },

      receiptSent () {
        this.showingReceiptModal = false
      },

      showInsuranceVerificationDetails (verificationDetails) {
        this.insuranceVerificationModalTitle = verificationDetails.insurancePriority + ' Insurance Verification Details'
        this.visitInsuranceVerificationDetails = verificationDetails
        this.showingInsuranceVerificationDetails = true
      },

      showVisitPaymentCash (visit) {
        this.cashPaymentVisit = visit
        this.showingVisitPaymentCashModal = true
      }
    },

    created () {
      document.addEventListener('visibilitychange', this.handleVisibilityChange)
      this.$store.$on('organization:changed', this.handleOrgChange)
      this.$store.$on('user:authenticated', this.handleLogin)
      const providerIds = localStorage.getItem('patientQueueSelectedProviderIds')
      if (providerIds) {
        this.selectedProviderIds = JSON.parse(providerIds)
      }
      const locationIds = localStorage.getItem('patientQueueSelectedLocationIds')
      if (locationIds) {
        this.selectedLocationIds = JSON.parse(locationIds)
      }
      const viewFilter = localStorage.getItem('patientQueueViewFilter')
      if (viewFilter) {
        this.visitStateFilter = JSON.parse(viewFilter)
      } else {
        if (this.visitStateFilter.length === 0) {
          this.visitStateFilter = this.visitStateOptions
        }
      }
      this.userAmPm = this.amOrPm
      if (this.$store.isAuthenticated) {
        this.loadVisits()
      }
    },

    beforeDestroy () {
      if (this.autoRefreshTimer) {
        clearTimeout(this.autoRefreshTimer)
      }
    }

  }
</script>

<style scoped>
    .pq-container {
        margin-bottom: 80px;
    }

    .slide-enter-active, .slide-leave-active {
        transition: all .3s ease-out;
        max-height: 220px;
        height: auto;
        overflow: hidden;
    }

    .slide-enter, .slide-leave-to {
        max-height: 0px;
        overflow: hidden;
    }

    .providers-filter {
        margin-left: 8px;
    }

    button.close {
        margin: 0px 0px 10px;
    }

    svg.danger {
        color: #dc3545;
    }

    header {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        margin: 0 0 30px 0;
    }

    header > h1 {
        color: rgb(255, 70, 0);
        font-weight: lighter;
        font-size: 28px;
        margin: 0;
    }

    header > h5 {
        margin-top: 0.5rem; /* Match bottom margin from bootstrap h5 */
    }

    .item-fade {
        transition: opacity 0.5s;
        -webkit-transition: opacity 0.5s;
        opacity: 1;
    }

    .visits-header div {
        padding: 0.75rem;
        vertical-align: bottom;
        border-top: 1px solid #dee2e6;
        border-bottom: 2px solid #dee2e6;
        font-weight: bold;
        border-collapse: collapse;
    }

    .visit-row .column {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        vertical-align: bottom;
        border-collapse: collapse;
    }

    .visit-row {
        border-bottom: 1px solid #dee2e6;
        background-color: #f9f9f9;
    }

    .visit-detail-row {
        padding-bottom: 0.75rem;
    }

    .patient-queue-row {
      cursor: pointer;
    }
    /* Application Styles */

    .filter-button {
        border: 1px solid rgb(255, 70, 0);
        background: white;
    }

    .print-summary {
        background: rgb(255, 213, 84);
        border: 0.5px solid rgb(255, 70, 0);
        color: rgb(255, 70, 0);
    }

    .print-summary:focus,
    .print-summary:focus:active,
    .print-summary:active,
    .print-summary:visited {
        background: rgba(255, 213, 84, 0.5);
        border: 0.5px solid rgba(255, 70, 0, 0.5);
        color: rgba(255, 70, 0, 0.5);
        outline: 5px auto rgba(255, 70, 0, 0.1);
    }

    .print-summary:hover {
        background: rgba(255, 213, 84, 0.5);
        border: 0.5px solid rgba(255, 70, 0, 0.5);
        color: rgba(255, 70, 0, 0.5);
    }

    .print-summary-modal.in .modal-dialog {
        position: absolute;
        top: 20px;
        bottom: 20px;
        left: 20px;
        right: 20px;
    }

    @media (min-width: 768px) {
        .print-summary-modal .modal-dialog {
            width: initial;
            margin: 0px;
        }
    }

    .print-summary-modal .modal-content,
    .print-summary-modal .modal-body {
        height: 100%;
    }

    .copay-due-pill {
        border: 1.5px solid rgba(171, 25, 25, 1);
        background: rgba(171, 25, 25, 1);;
        border-radius: 15px;
        text-align: center;
        color: white;
        width: 85px;
    }

    .copay-paid-pill {
        border: 1.5px solid rgba(55, 171, 25, 1);
        border-radius: 15px;
        text-align: center;
        color: rgba(55, 171, 25, 1);
        width: 85px;
    }

    .detail-panel-cell {
        border: 1px solid #ddd;
        height: 135px;
    }

    .field-label {
        color: #737284;
    }

    .dropdown-button {
        box-shadow: none !important;
        background-color: white;
    }

    /*!
     * Bootstrap-select v1.12.4 (https://silviomoreto.github.io/bootstrap-select)
     *
     * Copyright 2013-2017 bootstrap-select
     * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
     */

    select.bs-select-hidden,
    select.selectpicker {
        display: none !important;
    }

    .bootstrap-select {
        width: 120px \0;
        /*IE9 and below*/
    }

    .bootstrap-select > .dropdown-toggle {
        width: 100%;
        padding-right: 25px;
        z-index: 1;
    }

    .bootstrap-select > .dropdown-toggle.bs-placeholder,
    .bootstrap-select > .dropdown-toggle.bs-placeholder:hover,
    .bootstrap-select > .dropdown-toggle.bs-placeholder:focus,
    .bootstrap-select > .dropdown-toggle.bs-placeholder:active {
        color: #999;
    }

    .bootstrap-select > select {
        position: absolute !important;
        bottom: 0;
        left: 50%;
        display: block !important;
        width: 0.5px !important;
        height: 100% !important;
        padding: 0 !important;
        opacity: 0 !important;
        border: none;
    }

    .bootstrap-select > select.mobile-device {
        top: 0;
        left: 0;
        display: block !important;
        width: 100% !important;
        z-index: 2;
    }

    .has-error .bootstrap-select .dropdown-toggle,
    .error .bootstrap-select .dropdown-toggle {
        border-color: #b94a48;
    }

    .bootstrap-select.fit-width {
        width: auto !important;
    }

    .bootstrap-select:not([class*="col-"]):not([class*="form-control"]):not(.input-group-btn) {
        width: 120px;
    }

    .bootstrap-select .dropdown-toggle:focus {
        outline: thin dotted #333333 !important;
        outline: 5px auto -webkit-focus-ring-color !important;
        outline-offset: -2px;
    }

    .bootstrap-select.form-control {
        margin-bottom: 0;
        padding: 0;
        border: none;
    }

    .bootstrap-select.form-control:not([class*="col-"]) {
        width: 100%;
    }

    .bootstrap-select.form-control.input-group-btn {
        z-index: auto;
    }

    .bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {
        border-radius: 0;
    }

    .bootstrap-select.btn-group:not(.input-group-btn),
    .bootstrap-select.btn-group[class*="col-"] {
        float: none;
        display: inline-block;
        margin-left: 0;
    }

    .bootstrap-select.btn-group.dropdown-menu-right,
    .bootstrap-select.btn-group[class*="col-"].dropdown-menu-right,
    .row .bootstrap-select.btn-group[class*="col-"].dropdown-menu-right {
        float: right;
    }

    .form-inline .bootstrap-select.btn-group,
    .form-horizontal .bootstrap-select.btn-group,
    .form-group .bootstrap-select.btn-group {
        margin-bottom: 0;
    }

    .form-group-lg .bootstrap-select.btn-group.form-control,
    .form-group-sm .bootstrap-select.btn-group.form-control {
        padding: 0;
    }

    .form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,
    .form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {
        height: 100%;
        font-size: inherit;
        line-height: inherit;
        border-radius: inherit;
    }

    .form-inline .bootstrap-select.btn-group .form-control {
        width: 100%;
    }

    .bootstrap-select.btn-group.disabled,
    .bootstrap-select.btn-group > .disabled {
        cursor: not-allowed;
    }

    .bootstrap-select.btn-group.disabled:focus,
    .bootstrap-select.btn-group > .disabled:focus {
        outline: none !important;
    }

    .bootstrap-select.btn-group.bs-container {
        position: absolute;
        height: 0 !important;
        padding: 0 !important;
    }

    .bootstrap-select.btn-group.bs-container .dropdown-menu {
        z-index: 1060;
    }

    .bootstrap-select.btn-group .dropdown-toggle .filter-option {
        display: inline-block;
        overflow: hidden;
        width: 100%;
        text-align: left;
    }

    .bootstrap-select.btn-group .dropdown-toggle .caret {
        position: absolute;
        top: 50%;
        right: 12px;
        margin-top: -2px;
        vertical-align: middle;
    }

    .bootstrap-select.btn-group[class*="col-"] .dropdown-toggle {
        width: 100%;
    }

    .bootstrap-select.btn-group .dropdown-menu {
        min-width: 100%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .bootstrap-select.btn-group .dropdown-menu.inner {
        position: static;
        float: none;
        border: 0;
        padding: 0;
        margin: 0;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .bootstrap-select.btn-group .dropdown-menu li {
        position: relative;
    }

    .bootstrap-select.btn-group .dropdown-menu li.active small {
        color: #fff;
    }

    .bootstrap-select.btn-group .dropdown-menu li.disabled a {
        cursor: not-allowed;
    }

    .bootstrap-select.btn-group .dropdown-menu li a {
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .bootstrap-select.btn-group .dropdown-menu li a.opt {
        position: relative;
        padding-left: 2.25em;
    }

    .bootstrap-select.btn-group .dropdown-menu li a span.check-mark {
        display: none;
    }

    .bootstrap-select.btn-group .dropdown-menu li a span.text {
        display: inline-block;
    }

    .bootstrap-select.btn-group .dropdown-menu li small {
        padding-left: 0.5em;
    }

    .bootstrap-select.btn-group .dropdown-menu .notify {
        position: absolute;
        bottom: 5px;
        width: 96%;
        margin: 0 2%;
        min-height: 26px;
        padding: 3px 5px;
        background: #f5f5f5;
        border: 1px solid #e3e3e3;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
        pointer-events: none;
        opacity: 0.9;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .bootstrap-select.btn-group .no-results {
        padding: 3px;
        background: #f5f5f5;
        margin: 0 5px;
        white-space: nowrap;
    }

    .bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {
        position: static;
    }

    .bootstrap-select.btn-group.fit-width .dropdown-toggle .caret {
        position: static;
        top: auto;
        margin-top: -1px;
    }

    .bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark {
        position: absolute;
        display: inline-block;
        right: 15px;
        margin-top: 5px;
    }

    .bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {
        margin-right: 34px;
    }

    .bootstrap-select.show-menu-arrow.open > .dropdown-toggle {
        z-index: 1061;
    }

    .bootstrap-select.show-menu-arrow .dropdown-toggle:before {
        content: '';
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid rgba(204, 204, 204, 0.2);
        position: absolute;
        bottom: -4px;
        left: 9px;
        display: none;
    }

    .bootstrap-select.show-menu-arrow .dropdown-toggle:after {
        content: '';
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid white;
        position: absolute;
        bottom: -4px;
        left: 10px;
        display: none;
    }

    .bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {
        bottom: auto;
        top: -3px;
        border-top: 7px solid rgba(204, 204, 204, 0.2);
        border-bottom: 0;
    }

    .bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {
        bottom: auto;
        top: -3px;
        border-top: 6px solid white;
        border-bottom: 0;
    }

    .bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {
        right: 12px;
        left: auto;
    }

    .bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {
        right: 13px;
        left: auto;
    }

    .bootstrap-select.show-menu-arrow.open > .dropdown-toggle:before,
    .bootstrap-select.show-menu-arrow.open > .dropdown-toggle:after {
        display: block;
    }

    .bs-searchbox,
    .bs-actionsbox,
    .bs-donebutton {
        padding: 4px 8px;
    }

    .bs-actionsbox {
        width: 100%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .bs-actionsbox .btn-group button {
        width: 50%;
    }

    .bs-donebutton {
        float: left;
        width: 100%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .bs-donebutton .btn-group button {
        width: 100%;
    }

    .bs-searchbox + .bs-actionsbox {
        padding: 0 8px 4px;
    }

    .bs-searchbox .form-control {
        margin-bottom: 0;
        width: 100%;
        float: none;
    }

    .circle {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        padding-left: 0.6rem;
        padding-right: 0.5rem;
    }

    .circle.video {
        padding-left: 0.5rem;
    }

    .wide-button {
        width: 200px;
    }

    .kiosk-icon {
        overflow: visible;
        width: 1.25em;
        display: inline-block;
        font-size: inherit;
        height: 1em;
        vertical-align: -0.125em;
        margin-left: -0.125em;
    }

    .status-column {
      position: absolute;
      margin-right: 8px;
      width: 15px;
      height: 100%;
      left: 0px;
      top: 0px;
    }

    .mini-status-column {
      position: absolute;
      alignment: left;
      vertical-align: top;
      width: 8px;
      height: 23px;
      left: 18.5px;
      top: 1px;
      border-top-left-radius: 0.25em;
      border-bottom-left-radius: 0.25em;
    }

    .status-row {
      font-size: 11px;
      width: 450px;
      height: 40px;
      display: flex;
    }

    .status-item {
      alignment: center;
      position: relative;
      align-content: center;
      text-align: center;
      width: 75px;
      height: 40px;
    }

    .status-count {
      width: 40px;
      height: 25px;
      text-align: center;
      vertical-align: center;
      font-size: 13px;
      align-content: center;
      padding-top: 2px;
      padding-right: 3px;
    }

    .headshot-small  {
      height: 40px;
      width: 40px;
      margin-left: 20px;
      margin-right: 5px;
    }

    .button-header {
      font-weight: 500;
    }

    .btn-outline-orange.no-hover-color:HOVER {
      background-color: transparent;
      color: black;
    }

    #popover-target-1:focus {
      outline: none;
      box-shadow: none;
    }

    #popover-target-1:active {
      background-color: white;
      color: rgb(82, 140, 197);
    }

    .patient-name {
      font-size: 16px;
    }

    .popover-text {
      background-color: white;
      border: none;
      color: rgb(82, 140, 197);
      font-size: 14px;
      padding-left: 1px;
    }

    .wide-popover {
      max-width: 500px; }

    .scheduled-header {
      text-decoration-line: underline;
      text-decoration-color: #DDE2E6;
      text-decoration-thickness: 3px;
      font-weight: 500;
      text-underline-offset: 3px;
    }

    .precheck-header {
      text-decoration-line: underline;
      text-decoration-color: #8970B5;
      text-decoration-thickness: 3px;
      font-weight: 500;
      text-underline-offset: 3px;
    }

    .inprogress-header {
      text-decoration-line: underline;
      text-decoration-color: #528CC5;
      text-decoration-thickness: 3px;
      font-weight: 500;
      text-underline-offset: 3px;
    }

    .review-header {
      text-decoration-line: underline;
      text-decoration-color: #C52525;
      text-decoration-thickness: 3px;
      font-weight: 500;
      text-underline-offset: 3px;
    }

    .done-header {
      text-decoration-line: underline;
      text-decoration-color: #61CC6B;
      text-decoration-thickness: 3px;
      font-weight: 500;
      text-underline-offset: 3px;
    }

    .checkin-header {
      text-decoration-line: underline;
      text-decoration-color: #F2A43A;
      text-decoration-thickness: 3px;
      font-weight: 500;
      text-underline-offset: 3px;
    }

    .popover-subheader {
      font-weight: 500;
      font-size: 1rem !important;
    }

    .insurance-card-icon {
      max-height: 15px;
      max-width: 15px;
      margin-bottom: 2px;
      cursor: pointer;
    }

    @media (min-width: 768px) and (max-width: 1440px) {
      .patient-name-dob {
        padding-left: 20px;
      }
    }
    .patient-search {
      height: 36px;
    }
    .view-button-group {
      display: flex;
      align-items: center;
    }

    .header-label {
      font-weight: 500;
      margin-bottom: 2px;
    }
    .button-container {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .alert {
      margin-bottom: 0;
    }
</style>
